import { useCallback } from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { getCreatorLocation } from '~/core/utils';
import { ICreator } from '~/types';

import { useFeature } from './useFeatureFlag/useFeature';

export const useGetCreatorLocation = () => {
  const { isEnabled: isFoamTalentLocationEnabled } = useFeature(
    FEATURE_FLAGS.foamTalentLocation,
  );

  const getLocation = useCallback(
    (creator: ICreator) => {
      if (!isFoamTalentLocationEnabled)
        return creator?.city || creator?.location?.city || '';

      return getCreatorLocation(creator);
    },
    [isFoamTalentLocationEnabled],
  );

  return {
    getLocation,
  };
};
